export default {
  align: 'center',
  emptyBtn: false,
  submitBtn: false,
  labelWidth:"130",
  submitText: '保存',
  column: [
    {
      label: '车场名称',
      type: 'tree',
      prop: 'spaceId',
      span: 12,
      search: true,
      cell: true,
      clearable: false,
      disabled: true,
      props: {
        label: 'title',
        value: 'key',
      },
      rules: [
        {
          message: '请选择车场名称',
          required: true,
        },
      ],
      dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',

    },
    {
      label: '车牌号',
      prop: 'carNo',
      type: 'input',
      span: 12,
      disabled: true,
    },
    {
      label: '客户姓名',
      prop: 'customerName',
      type: 'input',
      maxlength:10,
      span: 12,
      rules:[
        {
          required: true,
          message: '请输入客户姓名',
          trigger: 'blur',
        }]
      // disabled: true,
    },
    {
      label: '手机号',
      prop: 'customerPhone',
      type: 'input',
      maxlength:11,
      span: 12,
      rules:[
        {
          required: true,
          message: '请输入手机号',
          trigger: 'blur',
        },
        { min: 11, max: 11, message: '长度为11个字符', trigger: 'blur' },
        { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '手机号格式错误' }
      ]
      // disabled: true,
    },
    {
      label: '收费标准',
      prop: 'ruleName',
      type: 'input',
      span: 12,
      disabled: true,
    },
    {
      label: '优惠券',
      prop: 'code',
      type: 'input',
      span: 12,
      formslot: true,
    },
    {
      label: '优惠金额',
      prop: 'couponAmount',
      type: 'input',
      span: 12,
      disabled: true,
    },
    {
      label: '开始时间',
      prop: 'startTime',
      type: 'input',
      span: 12,
      disabled: true,
    },
    {
      label: '续租时长',
      prop: 'cycleNum',
      span: 12,
      disabled: false,
      viewDisplay: false,
      hide: true,
      type: 'select',
      clearable:false,
      dicUrl: '/api/blade-system/dict/dictionary?code=car_month_package',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      rules: [
        {
          required: true,
          message: '请选择续租时长',
          trigger: 'change',
        },
      ],
    },
    {
      label: '结束时间',
      prop: 'buyEndTime',
      type: 'input',
      span: 12,
      disabled: true,
    },
    {
      label: '补缴临停费用',
      prop: 'supplementTempCarFee',
      span: 12,
      disabled: true,
      dataType: 'number',
      type: 'radio',
      formslot: true,
      rules: [{
        required: true,
        message: "请选择是否补缴临停费用",
        trigger: "blur"
      }],
      dicData: [
        {label: '是', value: 1},
        {label: '否', value: 0},
      ],
    },
    {
      label: '应缴金额',
      prop: 'shouldMoney',
      type: 'input',
      span: 12,
      disabled: true,
    },
    {
      label: '小区名称',
      prop: 'communityName',
      type: 'input',
      span: 12,
      display:false,
      disabled: true,
    },
    {
      label: '楼栋',
      prop: 'buildingId',
      type: 'input',
      span: 12,
      display:false,
      disabled: false,
      formslot: true,
    },
    {
      label: '房间',
      prop: 'roomId',
      type: 'input',
      span: 12,
      disabled: true,
      readonly:true,
      formslot: true,
    },

    {
      label: '收款方式',
      prop: 'payType',
      type: 'input',
      span: 12,
      disabled: false,
      formslot: true,
      rules: [
        {
          required: true,
          message: '请选择收款方式',
          trigger: 'change',
        },
      ],
    },
    {
      label: '收款类型',
      prop: 'payScene',
      type: 'input',
      span: 12,
      disabled: false,
      formslot: true,
      rules: [
        {
          required: true,
          message: '请选择收款类型',
          trigger: 'change',
        },
      ],
    },
    {
      label: '收款码',
      prop: 'authCode',
      type: 'input',
      span: 12,
      disabled: false,
      formslot: true,
    },



    // {
    //   label: '车牌号',
    //   prop: 'carNo',
    //   type: 'input',
    //   span: 12,
    //   disabled: true,
    // }

    // {
    //   label: '区域',
    //   prop: 'regions',
    //   // type: 'input',
    //   hide: true,
    //   span: 8,
    //   type: 'tree',
    //   multiple: true,
    //   checkStrictly: true,
    //   dataType: 'string',
    //   dicData: [],
    //   props: {
    //     label: 'title',
    //     value: 'id',
    //   },

    // },


  ],
};

